import { ButtonLink, Stack, StackItem } from '@asgard/ui-library';

import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { CardHighlight02 } from 'components/CardHighlight02/CardHighlight02';
import { CardHighlight03 } from 'components/CardHighlight03/CardHighlight03';
import { PageContentContainer } from 'components/layout/Page.styled';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import { TalentIntro } from '../components/intro/TalentIntro';
import { TalentOffersStyles } from './TalentOffers.styles';

export const TalentOffers: React.FC = () => {
  const { t } = useI18n('talent-new');
  const { locale } = useRouter();

  return (
    <TalentOffersStyles.Root>
      <Stack direction="column" gap="4xl">
        <PageContentContainer containerSize="xl">
          <TalentIntro
            className="intro"
            title={t('talent-new.offers.title')}
            desc={t('talent-new.offers.desc')}
          />

          <Stack direction="column" gap="4xl">
            <CardHighlight03>
              <TalentOffersStyles.CardContent1>
                <img
                  loading="lazy"
                  src={getPublicPath(
                    `/images/talent-new/talent-new-offers-feature1.webp`
                  )}
                  alt=""
                />

                <StackItem>
                  <h3>{t(`talent-new.offers.feature1.card-title`)}</h3>
                  <HtmlTrans
                    ns="talent-new"
                    i18nKey={`talent-new.offers.feature1.card-content`}
                  />
                </StackItem>
              </TalentOffersStyles.CardContent1>
            </CardHighlight03>

            <Stack>
              <CardHighlight02 className="half">
                <TalentOffersStyles.CardContent2>
                  <img
                    loading="lazy"
                    src={getPublicPath(
                      `/images/talent-new/talent-new-offers-feature2.webp`
                    )}
                    alt=""
                  />

                  <h3>{t('talent-new.offers.feature2.card-title')}</h3>
                  <HtmlTrans
                    ns="talent-new"
                    i18nKey={'talent-new.offers.feature2.card-content'}
                  />
                  <Link href={getAppUrl(APP_URLS.jobOffers, locale)} passHref>
                    <ButtonLink
                      schema="brand1"
                      variant="hard"
                      endIcon={faArrowRight}
                      size="s"
                      label={t('talent-new.offers.feature2.cta')}
                    />
                  </Link>
                </TalentOffersStyles.CardContent2>
              </CardHighlight02>

              <CardHighlight02 className="half">
                <TalentOffersStyles.CardContent2>
                  <img
                    loading="lazy"
                    src={getPublicPath(
                      `/images/talent-new/talent-new-offers-feature3.webp`
                    )}
                    alt=""
                  />

                  <h3>{t('talent-new.offers.feature3.card-title')}</h3>
                  <HtmlTrans
                    ns="talent-new"
                    i18nKey={'talent-new.offers.feature3.card-content'}
                  />
                  <Link
                    href={getAppUrl(APP_URLS.manfredDaily, locale)}
                    passHref
                  >
                    <ButtonLink
                      schema="brand1"
                      variant="hard"
                      endIcon={faArrowRight}
                      size="s"
                      label={t('talent-new.offers.feature3.cta')}
                    />
                  </Link>
                </TalentOffersStyles.CardContent2>
              </CardHighlight02>
            </Stack>
          </Stack>
        </PageContentContainer>
      </Stack>
    </TalentOffersStyles.Root>
  );
};

export default TalentOffers;
